// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentSurveyAnswer {
    static getAttributeTypeMap() {
        return BasicEnrollmentSurveyAnswer.attributeTypeMap;
    }
}
BasicEnrollmentSurveyAnswer.discriminator = undefined;
BasicEnrollmentSurveyAnswer.additionalProperties = false;
BasicEnrollmentSurveyAnswer.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=basicEnrollmentSurveyAnswer.js.map